import { useRef } from "react";
import * as Dialog from "@radix-ui/react-dialog";

export const Sheet = ({ open, onOpenChange, title, children, testId, className = "", returnFocusRef }) => {
  const titleRef = useRef(null);
  const openerRef = useRef(null);
  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay className="sheet-overlay-in fixed inset-0 z-40 bg-black/50" />
        <Dialog.Content
          data-testid={testId}
          aria-describedby={undefined}
          onOpenAutoFocus={(e) => {
            e.preventDefault();
            openerRef.current = document.activeElement;
            titleRef.current?.focus();
          }}
          onCloseAutoFocus={(e) => {
            const target = returnFocusRef?.current ?? openerRef.current;
            if (target?.isConnected && target !== document.body) {
              e.preventDefault();
              target.focus({ preventScroll: true });
            }
          }}
          className={`sheet-in fixed inset-x-0 bottom-0 z-50 max-h-[90vh] overflow-y-auto rounded-t-[12px] border border-ax-border bg-ax-surface p-6 pb-[calc(24px+var(--safe-bottom))] text-ax-text shadow md:inset-auto md:left-1/2 md:top-1/2 md:w-[400px] md:-translate-x-1/2 md:-translate-y-1/2 md:rounded-[12px] md:pb-6 ${className}`}
        >
          <Dialog.Title ref={titleRef} tabIndex={-1} className="type-h2 m-0 outline-none">
            {title}
          </Dialog.Title>
          <div className="mt-4">{children}</div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};
